<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  style="position: absolute; overflow: hidden"
>
  <defs>
    <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%">
      <feTurbulence
        type="fractalNoise"
        baseFrequency="0.008 0.008"
        numOctaves="2"
        seed="92"
        result="noise"
      ></feTurbulence>
      <feGaussianBlur
        in="noise"
        stdDeviation="2"
        result="blurred"
      ></feGaussianBlur>
      <feDisplacementMap
        in="SourceGraphic"
        in2="blurred"
        scale="77"
        xChannelSelector="R"
        yChannelSelector="G"
      ></feDisplacementMap>
    </filter>
  </defs>
</svg>

<nav
  class="navbar navbar-expand-lg fixed-top px-3 py-2"
  [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
  #navbar
>
  <a class="navbar-brand" [routerLink]="['/' + lang + '/home']">
    <img [src]="logoPath" alt="Company Logo" class="logo" />
  </a>

  <button
    class="navbar-toggler border-0 active"
    type="button"
    (click)="toggleNavbar()"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div
    [ngClass]="{
      'collapse navbar-collapse justify-content-end': true,
      show: isMenuOpen
    }"
    id="navbarNav"
  >
    <ul class="navbar-nav gap-lg-4 text-center">
      <li class="nav-item" *ngFor="let tab of tabs">
        <ng-container *ngIf="tab.children?.length; else noChildren">
          <div class="dropdown">
            <a
              class="nav-link dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              [ngClass]="{ active: isChildActive(tab) }"
            >
              {{ tab.name | translate }}
            </a>
            <ul class="dropdown-menu border-0">
              <li *ngFor="let child of tab.children">
                <a
                  class="dropdown-item text-center text-lg-start"
                  [routerLink]="'/' + lang + child.route"
                  [fragment]="child.id"
                  (click)="closeNavbar()"
                  routerLinkActive="active"
                >
                  {{ child.lable | translate }}
                </a>
              </li>
            </ul>
          </div>
        </ng-container>
        <ng-template #noChildren>
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="'/' + lang + tab.route"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeNavbar()"
          >
            {{ tab.name | translate }}
          </a>
        </ng-template>
      </li>

      <li
        class="nav-item dropdown language-selector d-flex align-items-center"
        *ngIf="selectedLanguage"
      >
        <button
          class="btn lang-btn d-flex align-items-center gap-2"
          type="button"
          id="languageDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            [src]="selectedLanguage.flag"
            alt="{{ selectedLanguage.name }}"
            class="lang-flag"
          />
          <span class="lang-name">{{ selectedLanguage.name }}</span>
        </button>

        <ul
          class="dropdown-menu dropdown-menu-start mt-2 shadow-sm border-0"
          [ngClass]="{
        'dropdown-menu-start': lang === 'ar',
        'dropdown-menu-end': lang !== 'ar',
        }"
        >
          <li *ngFor="let language of languages">
            <a
              class="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
              [href]="getNewURL(language.value)"
              (click)="selectLanguage(language.value)"
              [class.active]="selectedLanguage.name === language.name"
            >
              <img
                [src]="language.flag"
                alt="{{ language.name }}"
                class="lang-flag"
              />
              <span class="lang-name">{{ language.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>
